module.exports = __webpack_public_path__ + "img/html5.eb0bfe64.svg";